<template>
  <Print v-if="isPrint" :board="board" :form="form" :header="header" />
  <div v-else>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :readonly="board.readonly" />

    <div>
      <h5 class="my-4"><i class="dot"></i> 회의정보</h5>
      <div class="writeGridContainer">
        <div>
          <div>회의구분</div>
          <radio-group
            :items="[
              { label: '상반기', value: '상반기' },
              { label: '하반기', value: '하반기' },
              { label: '수시', value: '수시' },
            ]"
            v-model="form.회의구분"
            :readonly="board.readonly"
            :row-count="isMobile? 1 : 3"
          />
        </div>
        <div />
        <div />
        <div>
          <div>회의일</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.회의일 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.회의일" />
        </div>
        <div>
          <div>실시시간</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.실시시간 }}</p>
          <time-selector-rang v-else :readonly="board.readonly" v-model="form.실시시간" />
        </div>
        <div>
          <div>장소</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.회의장소 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="form.회의장소" />
        </div>
        <div>
          <div>참석인원</div>
          <div class="flex items-center gap-2">
            <p v-if="isPrint" class="print-input flex-1">{{ form.참석인원 }}</p>
            <number-input v-else class="w-full" :readonly="true" v-model="form.참석인원" :min="0" />
            <span>명</span>
          </div>
        </div>
      </div>
    </div>

    <div>
      <h5 class="my-4"><i class="dot"></i> 회의내용</h5>
      <div :class="!isMobile ? 'writeGridContainer' : ''">
        <div class="writeGridLineItem">
          <div>협의 및 의결사항</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.협의및의결사항 }}</p>
          <ml-textarea v-else :readonly="board.readonly" v-model="form.협의및의결사항" rows="10"/>
        </div>
        <div class="writeGridLineItem">
          <div>기타사항</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.기타사항 }}</p>
          <ml-textarea v-else :readonly="board.readonly" v-model="form.기타사항" />
        </div>
      </div>
    </div>

    <table-custom
      :board="board"
      :is-print="isPrint"
      title="참석자 명단"
      :tableData="[
        { id: '직책', title: '직책', type: 'text', placeholder: '' },
        { id: '직급', title: '직급', type: 'text', placeholder: '' },
        { id: '성명', title: '성명', type: 'text', placeholder: '' },
        { id: '서명', title: '서명', type: 'sign', placeholder: '' },
        { id: '비고', title: '비고', type: 'text', placeholder: '' },
      ]"
      :mobile="['직책', '성명']"
      v-model="form.참석자명단"
      :separate-button-row="isMobile"
      class="mt-28px"
    >
      <template #buttons="{ handleAddButton, handleRemoveButton, checkData }">
        <div :class="isMobile ? 'grid grid-cols-2 gap-2 w-full' : 'flex'">
          <vs-button
            color="secondary"
            type="border"
            :class="isMobile ? 'w-full' : 'ml-4'"
            @click="showMemberPopup = true"
          >
            사용자 불러오기
          </vs-button>
          <vs-button
            color="secondary"
            type="border"
            :class="isMobile ? 'w-full' : 'ml-4'"
            @click="showEmployeePopup = true"
          >
            종사자 정보 불러오기
          </vs-button>
          <vs-button
            color="secondary"
            :class="isMobile ? 'w-full' : 'ml-4'"
            @click="handleAddButton"
          >
            항목추가
          </vs-button>
          <vs-button
            color="secondary"
            type="border"
            :class="isMobile ? 'w-full' : 'ml-4'"
            @click="handleRemoveButton"
          >
            선택삭제
          </vs-button>
        </div>
      </template>
    </table-custom>

    <!-- 사진대지 -->
    <photo-upload-grid-module :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly" section-title="사진대지" placeholder="점검 현장 사진" />

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <popup-member v-model="showMemberPopup" :multiple="true" @handleClickSelect="handleLoadUser" />

    <popup-search-employee v-model="showEmployeePopup" :multiple="true" @handleClickSelect="handleLoadWorker" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import PopupSearchEmployee from "@/popup/PopupSearchEmployee.vue";
import PopupMember from "@/views/boards/single-page/1072/PopupMember.vue";
import Print from "@/views/boards/single-page/1072/Print.vue";
import TimeSelectorRang from "@/components/selector/TimeSelectorRang.vue";

export default {
  components: {
    TimeSelectorRang,
    Print,
    PopupMember,
    PopupSearchEmployee,
    TableCustom,
    TimeSelector,
    RadioGroup,
    FileUploadModule,
    FieldSelectModule,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  async created() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  data() {
    return {
      isMobile: false,
      showEmployeePopup: false,
      showMemberPopup: false,

      form: {
        stdInfo: {},
        photoList: [],
        fileList: [],

        회의구분: "",
        회의일: "",
        실시시간: { sTime: "", eTime: "" },
        회의장소: "",
        참석인원: "",
        협의및의결사항: "",
        기타사항: "",
        참석자명단: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    "form.참석자명단.length": {
      immediate: true,
      handler(newLength) {
        this.form.참석인원 = newLength;
      },
    }
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
    handleLoadUser(users) {
      for (const user of users) {
        // 중복된 이름이 있는지 확인 (직책, 직급, 성명)
        const isDuplicate = this.form.참석자명단.some((item) => item.직책 === user.rank && item.직급 === user.position && item.성명 === user.name);
        if (!isDuplicate) {
          this.form.참석자명단.push({
            id: Date.now() + '_' + Math.random().toString(36).substr(2, 9),
            직책: user.rank,
            직급: user.position,
            성명: user.name,
            서명: "",
            비고: "",
          });
        }
      }
    },
    handleLoadWorker(workers) {
      for (const worker of workers) {
        // 중복된 이름이 있는지 확인 (직책, 직급, 성명)
        const isDuplicate = this.form.참석자명단.some((item) => item.직책 === worker.employment_type && item.직급 === worker.job_title && item.성명 === worker.full_name);
        if (!isDuplicate) {
          this.form.참석자명단.push({
            id: Date.now() + '_' + Math.random().toString(36).substr(2, 9),
            직책: worker.employment_type,
            직급: worker.job_title,
            성명: worker.full_name,
            서명: "",
            비고: "",
          });
        }
      }
    },
  },
};
</script>
